import Cookies from 'js-cookie';

import {
  restoreLocalStorageSnapshot,
  snapshotPersistentPromptKeys,
} from './persistentLocalStorage';

export const clearStorage = () => {
  const promptSnapshot = snapshotPersistentPromptKeys();

  Cookies.remove('tokenData');
  Cookies.remove('expiresIn');
  localStorage.removeItem('devTokenData');
  localStorage.clear();
  restoreLocalStorageSnapshot(promptSnapshot);
  sessionStorage.clear();
};
